import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { HSLogo } from '@/components/HSLogo';
import { Button } from '@/components/ui/button';
import LiveChat from '@/components/LiveChat';

const SEOLayout = ({ title, description, children }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    document.title = title || 'HumanScaled — Controlled AI Infrastructure';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute('content', description || '');
    else {
      const m = document.createElement('meta');
      m.name = 'description';
      m.content = description || '';
      document.head.appendChild(m);
    }
  }, [title, description]);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <div className="noise-overlay" />
      <nav className="sticky top-0 z-50 bg-[#050505]/80 backdrop-blur-md border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5"><HSLogo size={32} /><span className="font-black text-xl tracking-tight">HumanScaled</span></Link>
          <div className="flex items-center gap-3 text-sm">
            <Link to="/for-business" className="text-muted-foreground hover:text-white hidden md:block">Business</Link>
            <Link to="/for-operators" className="text-muted-foreground hover:text-white hidden md:block">Operators</Link>
            <Link to="/case-studies" className="text-muted-foreground hover:text-white hidden md:block">Case Studies</Link>
            <Link to="/careers" className="text-muted-foreground hover:text-white hidden md:block">Careers</Link>
            <Button onClick={() => navigate('/signup')} className="bg-emerald-500 text-black hover:bg-emerald-400 font-bold px-5 h-9 rounded-sm">Get Started</Button>
          </div>
        </div>
      </nav>
      {children}
      <footer className="border-t border-white/5 py-8">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2.5"><HSLogo size={24} /><span className="font-black text-sm">HumanScaled</span></div>
            <div className="flex gap-6 text-xs text-muted-foreground">
              <Link to="/for-business" className="hover:text-white">For Business</Link>
              <Link to="/for-operators" className="hover:text-white">For Operators</Link>
              <Link to="/for-laid-off-tech" className="hover:text-white">Career Transition</Link>
              <Link to="/careers" className="hover:text-white">Careers</Link>
              <Link to="/case-studies" className="hover:text-white">Case Studies</Link>
              <Link to="/pricing" className="hover:text-white">Pricing</Link>
            </div>
            <p className="text-xs text-muted-foreground">Human control. Machine execution. Measured results.</p>
          </div>
        </div>
      </footer>
      <LiveChat />
    </div>
  );
};

export default SEOLayout;
